import React, { useState } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { useSelector } from 'react-redux';
import PageContainer from 'containers/PageContainer';
import SignupView from 'views/SignupView';
import { Auth } from 'lib/Amplify';
import { Redirect } from 'react-router';
import useMessages from 'hooks/useMessages';

const SignupContainer = ({ history }) => {
  const email = useSelector((state) => state.email);
  const [error, setError] = useState('');
  const { genericFailureMessage } = useMessages();

  const handleSubmit = (password) => {
    Auth.signUp({
      username: email,
      email,
      password,
    })
      .then(() => {
        history.replace('/verify');
      })
      .catch((err) => {
        switch (err.code) {
          case 'InvalidPasswordException':
            setError('Sorry, that password doesn\'t meet the security requirements. Please try again');
            break;
          default:
            genericFailureMessage();
        }
      });
  };

  if (!email) {
    return <Redirect to="/start" />;
  }

  return (
    <PageContainer hasBack>
      <SignupView
        email={email}
        error={error}
        onSubmit={handleSubmit}
        onChange={() => setError(null)}
        minPasswordLength={8}
      />
    </PageContainer>
  );
};

SignupContainer.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
};

SignupContainer.displayName = 'SignupContainer';

export default SignupContainer;
